export default __webpack_public_path__ + "images/4M.030c42f.png";